<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 100%">
                <el-row class="filter-bar" ref="filterBar">
                    <el-select size="mini" v-model="formDatas.arfrFrom" clearable @change="partserch"
                        placeholder="请选择回退渠道" style="width: 180px;">
                        <el-option label="系统" :value="1"></el-option>
                        <el-option label="易宝通" :value="2"></el-option>
                        <el-option label="河北小程序" :value="3"></el-option>
                        <!-- 4=内部商城(内部商城退款回补,回退渠道跟随原扣减渠道) -->
                        <el-option label="内部商城" :value="4"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.phone" clearable placeholder="请输入手机号"
                        style="width: 150px;" @keyup.enter.native="partserch"></el-input>
                    <el-input size="mini" v-model="formDatas.uniqueNum" clearable placeholder="请输入唯一凭证"
                        style="width: 180px;" @keyup.enter.native="partserch"></el-input>
                    <el-select size="mini" v-model="formDatas.arfrStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px;">
                        <el-option label="成功" :value="1"></el-option>
                        <el-option label="失败" :value="2"></el-option>
                    </el-select>
                       <el-select size="mini" v-model="formDatas.arfrSyncEquityfee" clearable @change="partserch"
                        placeholder="是否同步" style="width: 130px;">
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
          </div>
        </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import {
    getAjefRightsFundRollbackList
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "arfrFrom",
                    key: "arfrFrom",
                    title: "回退渠道",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        // 回退渠道:1系统 2易宝通 3河北小程序 4内部商城(跟随原扣减渠道)
                        return row.arfrFrom == 1 ? '系统' : row.arfrFrom == 2 ? '易宝通' : row.arfrFrom == 4 ? '内部商城' : '河北小程序';
                    },
                },
                {
                    field: "phone",
                    key: "phone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "uniqueNum",
                    key: "uniqueNum",
                    title: "唯一凭证",
                    align: "center",
                    width: 200,
                },
                {
                    field: "resultRollback",
                    key: "resultRollback",
                    title: "移动侧回退信息",
                    align: "center",
                    width: 250,
                },
                {
                    field: "arfrStatus",
                    key: "arfrStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfrStatus == 1 ? <el-tag type="success">成功</el-tag> : <el-tag type="danger">失败</el-tag>;
                    },
                },
                {
                    field: "arfrSyncEquityfee",
                    key: "arfrSyncEquityfee",
                    title: "是否同步",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfrSyncEquityfee == 1 ? '否' : row.arfrSyncEquityfee == 2 ? '是' : '-';
                    },
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
                { field: "createusername", key: "createusername", title: "创建人", width: 100, align: "center" },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = calcTableHeight(this, val, 140);
            });
        },
    },
    deactivated() {},
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() {},
    methods: {
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundRollbackList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundRollbackList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundRollbackList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
